.banner {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border: 1px solid #42b4e6;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  background-color: #ffffff;
  box-sizing: border-box;
}

.banner *,
.banner *::before,
.banner *::after {
  box-sizing: inherit;
}

.banner::before {
  content: "";
  position: absolute;
  top: 0;
  width: 40px;
  height: 40px;
  background-color: #42b4e6;
}

:host(:not([dir="rtl"])) .banner::before {
  left: 0;
  border-bottom-right-radius: 100%;
}

:host([dir="rtl"]) .banner::before {
  right: 0;
  border-bottom-left-radius: 100%;
}

.banner__corner-icon {
  position: absolute;
  top: 8px;
}

:host(:not([dir="rtl"])) .banner__corner-icon {
  left: 8px;
}

:host([dir="rtl"]) .banner__corner-icon {
  right: 8px;
}